// import React from "react";

// import TopConvertingProducts from "../../../../components/ClientDashboard/analytics-components/ProductPerformance/TopConvertingProducts";
// import HighClicksLowConversions from "../../../../components/ClientDashboard/analytics-components/ProductPerformance/HighClicksLowConversions";
// import MostRecommendedCategories from "../../../../components/ClientDashboard/analytics-components/ProductPerformance/MostRecommendedCategories";


// const ProductPerformanceAnalytics = () => {
//   return (
//     <div>
//       <TopConvertingProducts />
//       <HighClicksLowConversions/>
//       <MostRecommendedCategories/>
//     </div>
//   );
// };

// export default ProductPerformanceAnalytics;


import React from "react";
import { useOutletContext } from "react-router-dom";

import TopConvertingProducts from "../../../../components/ClientDashboard/analytics-components/ProductPerformance/TopConvertingProductsMain";
import HighClicksLowConversions from "../../../../components/ClientDashboard/analytics-components/ProductPerformance/HighClicksLowConversions";
import MostRecommendedCategories from "../../../../components/ClientDashboard/analytics-components/ProductPerformance/MostRecommendedCategories";


const ProductPerformanceAnalytics = () => {
  const { dateFilterValue } = useOutletContext();

  return (
    <div>
      <TopConvertingProducts dateFilterValue={dateFilterValue} />
      <HighClicksLowConversions dateFilterValue={dateFilterValue} />
      <MostRecommendedCategories dateFilterValue={dateFilterValue} />
    </div>
  );
};

export default ProductPerformanceAnalytics;
